import React, {useEffect, useState } from 'react';
import { Row, Space,Button,Modal,Col, Radio, RadioChangeEvent } from 'antd';
import { FormProps } from '../../../utility/types';
import { useForm } from '../../../utility/useForm';
import { NoValidateForm, validateLoginForm } from '../../../utility/validationRules';
import { ValidationErrorSpan } from '../../../styles/global';
import { errorNotify, sucessNotify } from '../../../services/toast.notification';
import FormContainer from '../../../components/FormContainer/FormContainer';
import CustomTextArea from '../../../components/_common/CustomTextArea';
import CustomTable from '../../../components/_common/Table';
import { ColumnsType } from 'antd/lib/table';
import {  getMachineRequest, getMachineRequestWhithOutConfirm } from '../../../api/api';
import { useAppSelector } from '../../../redux/store/storehooks';
import Input from '../../../components/_common/Input';


export const ConfirmRequestMachin: React.FC<FormProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog}) => {
  const myStore = useAppSelector((state) => state)
    const [value, setValue] = useState(1);
    const [width, setWidth] = useState(1000);
    const [isLoading,setIsLoading] = useState(false);
    const onChange = (e: RadioChangeEvent) => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
        // if(e.target.value==1){

        // }
        // if(e.target.value==2){

        // }
     
      };
      const confirmItem = () => {
        

            setIsLoading(true);
            value==1?
            MachineRequestWhithOutConfirm():
            MachineRequest();
        
        
        
    }
    const MachineRequest=()=>{
      getMachineRequest(objectMaper())
      .then((result:any) => {
        
        sucessNotify("اطلاعات شما با موفقیت ثبت گردید", undefined, 5000)
        setIsLoading(false);
       
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage,undefined,5000)
       
      })
    }
    const MachineRequestWhithOutConfirm=()=>{
      getMachineRequestWhithOutConfirm(objectMaper())
      .then((result:any) => {
        
        sucessNotify("اطلاعات شما با موفقیت ثبت گردید", undefined, 5000)
       
        setIsLoading(false);
       
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage,undefined,5000)
       
      })
    }
   const objectMaper=()=>{
    let model:any={}; 
    model.labId=payLoad.labId
    model.mobile=payLoad.mobile
    model.requestId= 0
    model.machineId= payLoad.prk_MachineVLabInstallRequest_AutoID
    model.status= 0
    model.financialUserId= myStore.auth.userId
    model.ticketId= 0
    model.financialDate=''
    model.financialTime=""
    model.installerId=payLoad.frk_CenteralInstallerUserID 
    model.finilizeDate= ""
    model.finilizeTime= ""
    model.orderDesc=""
    model.parsipoldesc= ""
    model.installKey=""
    model.deleted= false
    return model
    }
   
    useEffect(()=>{
      getWindowWith()
       
    },[])
    const getWindowWith=()=>{
      let w = window.innerWidth;
          setWidth(w-400)
    }
 
    return (
        <Modal
        // width: 'calc(100vh - 200px)'
        width={width}
        bodyStyle={{ overflowX: 'auto',direction:'rtl',padding:'25px' }}
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
  
        >
             <Radio.Group 
             style={{marginTop:'15px'}}
             onChange={onChange} value={value}>
      <Radio value={1}>با تایید مالی</Radio>
      <Radio value={2}>بدون تایید مالی</Radio>
    </Radio.Group>
        
        {(() => {
        if (value==1) {
           return <div style={{paddingRight:'10px'}}>
           هشدار : کاربر گرامی  در صورت تایید مالی مبلغ 
          <span style={{paddingRight:'10px',paddingLeft:'6px' ,scrollPaddingRight:'6px',color:'green',display:'inline-block'}}>
          {payLoad.int_MachineInstallPrice}
          </span>
          
            مبلغ مورد تایید میباشد
           <p style={{marginTop:'10px'}}>
           <Button 
             onClick={()=>
                confirmItem()}
            style={{background:"green",color:'white',paddingRight:'10px'}}>
                ثبت
            </Button>
           </p>
            </div>  
            
        } 
        else{
            return <p style={{paddingRight:'10px'}}>
             
                
                <Button 
             onClick={()=>
                confirmItem()}
            style={{background:"green",color:'white',paddingRight:'10px'}}>
                ثبت
            </Button>
            </p>   
        }
      })()}
       
        </Modal>
    )
}